import { render, staticRenderFns } from "./leveThreePageZXKT.vue?vue&type=template&id=5961bf66&scoped=true&"
import script from "./leveThreePageZXKT.vue?vue&type=script&lang=js&"
export * from "./leveThreePageZXKT.vue?vue&type=script&lang=js&"
import style0 from "./leveThreePageZXKT.vue?vue&type=style&index=0&id=5961bf66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961bf66",
  null
  
)

export default component.exports